import { ReactNode } from 'react';
import { useLang } from 'hooks/lang';

import { loaders, invoiceControlStatusConfig } from 'entities';

import {
  AlarmCheckIcon,
  ClockIcon,
  FolderIcon,
  HalfFilledCircleArrowIcon,
  DollarBillIcon,
  ReceiptLongIcon,
  CircleXIcon,
  UserMinusIcon,
  ListToDoIcon,
} from 'components/Icons';

import { CardGrid } from './CardGrid';

// if we use this elsewhere, we need to put it inside the config, probably tie the colors there too.
const iconMapping: Record<string, ReactNode> = {
  [invoiceControlStatusConfig.unassigned.code]: <UserMinusIcon color="#fc8a05" />,

  [invoiceControlStatusConfig.waitingInvoiceInfo.code]: <ClockIcon color="#636973" />,

  [invoiceControlStatusConfig.readyToInvoice.code]: <AlarmCheckIcon color="#014272" />,

  [invoiceControlStatusConfig.partiallyInvoiced.code]: (
    <HalfFilledCircleArrowIcon color="#ffb800" />
  ),

  [invoiceControlStatusConfig.invoiced.code]: <ReceiptLongIcon color="#0695fd" />,

  [invoiceControlStatusConfig.paid.code]: <DollarBillIcon color="#19c29b" />,

  [invoiceControlStatusConfig.pendingApproval.code]: <ListToDoIcon color="#FF007D" />,

  [invoiceControlStatusConfig.canceled.code]: <CircleXIcon color="#e47474" />,
};

export function InvoiceProjects() {
  const { t } = useLang();

  const { data, errorOrLoading } = loaders.invoice.invoiceProjectsCounts.use({
    defaultValue: {},

    realTimeSubscription: {
      type: 'INVOICE_CONTROL_COUNTS',

      onMessage: ({ counts }) => counts,
    },
  });

  return (
    <CardGrid
      title={t('projects')}
      icon={<FolderIcon color="#fff" />}
      loading={errorOrLoading}
      items={Object.values(invoiceControlStatusConfig).map(({ getLabel, code, routeId }) => ({
        getLabel,
        to: 'invoiceProjectsByStatus',
        params: { status: routeId },
        count: data[code] ?? 0,
        icon: iconMapping[code],
      }))}
    />
  );
}
